export default __webpack_public_path__ + "static/media/Armbands of Jagged Barbs.b74a4f73.jpg";